import * as React from "react";
import {ISvgIconProps, SvgIcon} from "../../../basic-ui-components/icon/svg-icon/svg.icon";

export class LoadingCircleLargeIcon extends React.Component<ISvgIconProps, {}> {
    render() {
        return <SvgIcon {...this.props} viewBox="0 0 300 300">
            <path d="M150,0C67.2,0,0,67.2,0,150s67.2,150,150,150s150-67.2,150-150S232.8,0,150,0z M150,210c-33.1,0-60-26.9-60-60 s26.9-60,60-60s60,26.9,60,60S183.1,210,150,210z"/>
            <g>

                <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="75" y1="207.3566" x2="75" y2="153.8727" gradientTransform="matrix(1 0 0 -1 0 302)">
                    <stop offset="0" stopColor="#FFFFFF"/>
                    <stop offset="1" stopColor="#FFFFFF" stopOpacity="0"/>
                </linearGradient>

                <path className="st0" fill="url(#SVGID_1_)" d="M0,150h90c0-33.1,26.9-60,60-60V0C67.2,0,0,67.2,0,150z"/>
                <path className="st1" fill="#FFFFFF" d="M149,90c0.3,0,0.7,0,1,0c16.6,0,31.6,6.7,42.4,17.6l0.1-0.1c8.1,8.1,19.4,13.2,31.8,13.2c24.9,0,45-20.1,45-45 c0-13.5-6-25.6-15.4-33.9C227,15.9,190.3,0,150,0c-0.3,0-0.7,0-1,0V90z"/>

                <animateTransform accumulate="none" additive="replace" attributeName="transform" attributeType="XML"
                                  calcMode="linear" dur="0.85s" fill="remove" from="0 150 150" repeatCount="indefinite"
                                  restart="always" to="360 150 150" type="rotate">
                </animateTransform>
            </g>
        </SvgIcon>;
    }
}
